import AppContext from "@helpers/context";
import { useContext } from "react";
import CartRuleGeneralForm from "../component/CartRuleGeneralForm";

export default function CartRuleCreateInfo() {
  const { cartRuleForm } = useContext(AppContext);
  return <CartRuleGeneralForm form={cartRuleForm} />;
}
